// The code in this file will load on every page of your site

$w.onReady(function () {
	// Write your code here
});

$w('#section50').onViewportEnter((event) => {
})

$w('#box188').onFocus((event) => {
})